import { render, staticRenderFns } from "./Journeys.vue?vue&type=template&id=f451f558&"
import script from "./Journeys.vue?vue&type=script&lang=js&"
export * from "./Journeys.vue?vue&type=script&lang=js&"
import style0 from "./Journeys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports